import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import { useCallback, useEffect, useState } from 'react';
import { useHover } from 'react-use';
import { setBlockSelection } from 'components/common/RichTextEditor/util/block';
import { Container, DownIcon, MoveBlockButton, SelectButton, UpIcon } from './EditBlockToolbar.style';

var EditBlockToolbar = function EditBlockToolbar(_ref) {
  var block = _ref.block,
      onSelectClick = _ref.onSelectClick,
      moveBlockUpOrDown = _ref.moveBlockUpOrDown,
      updateBlockData = _ref.updateBlockData,
      editorState = _ref.editorState;
  var moveBlockCallback = useCallback(function (direction) {
    return function () {
      moveBlockUpOrDown(block.getKey(), direction);
    };
  }, [moveBlockUpOrDown, block]);
  var EditBlockToolBarContent = useCallback(function (isHovering) {
    return __jsx(Container, null, isHovering ? __jsx(React.Fragment, null, __jsx(MoveBlockButton, {
      onClick: moveBlockCallback('up')
    }, __jsx(UpIcon, null)), __jsx(SelectButton, {
      onClick: onSelectClick
    }), __jsx(MoveBlockButton, {
      onClick: moveBlockCallback('down')
    }, __jsx(DownIcon, null))) : __jsx(SelectButton, {
      onClick: onSelectClick
    }));
  }, [moveBlockCallback, onSelectClick]);

  var _useHover = useHover(EditBlockToolBarContent),
      _useHover2 = _slicedToArray(_useHover, 2),
      HoverableEditBlockToolBarContent = _useHover2[0],
      isHovering = _useHover2[1];

  var _useState = useState(isHovering),
      isBlockSelected = _useState[0],
      setIsBlockSelected = _useState[1];

  useEffect(function () {
    if (isHovering !== isBlockSelected) {
      setBlockSelection(editorState, block.getKey(), updateBlockData, isHovering);
      setIsBlockSelected(isHovering);
    }
  }, [isHovering, isBlockSelected, block, editorState, updateBlockData]);
  return HoverableEditBlockToolBarContent;
};

export default EditBlockToolbar;